/**
 * Halloween Event Assets
 */

// Gold theme Halloween assets
import goldLogoLight from './gold/logo/logo_light.svg'
import goldLogoDark from './gold/logo/logo_dark.svg'
import goldLoadingBg1 from './gold/loadingscreen/loading_screen_bg.jpg'

// Gold theme Halloween models
import goldChinaModel from './gold/models/china-model.png'
import goldEgyptModel from './gold/models/egypt-model.png'
import goldEnglandModel from './gold/models/england-model.png'
import goldGermanyModel from './gold/models/germany-model.png'
import goldHangsengModel from './gold/models/hangseng-model.png'
import goldIndiaModel from './gold/models/india-model.png'
import goldJapanModel from './gold/models/japan-model.png'
import goldKoreaModel from './gold/models/korea-model.png'
import goldLaosModel from './gold/models/laos-model.png'
import goldMalaysiaModel from './gold/models/malaysia-model.png'
import goldMaltaModel from './gold/models/malta-model.png'
import goldRussiaModel from './gold/models/russia-model.png'
import goldSingaporeModel from './gold/models/singapore-model.png'
import goldTaiwanModel from './gold/models/taiwan-model.png'
import goldThailandModel from './gold/models/thailand-model.png'
import goldUsaModel from './gold/models/usa-model.png'
import goldVietnamModel from './gold/models/vietnam-model.png'

// Halloween decoration assets
import goldWebLeft from './gold/decorations/web-left.svg'
import goldWebRight from './gold/decorations/web-right.svg'
import blueWebLeft from './blue/decorations/web-left.svg'
import blueWebRight from './blue/decorations/web-right.svg'

// Blue theme Halloween assets
import blueLogoLight from './blue/logo/logo_light.svg'
import blueLogoDark from './blue/logo/logo_dark.svg'
import blueLoadingBg1 from './blue/loadingscreen/loading_screen_bg.jpg'
import blueSkull from './blue/decorations/skull.svg'
import goldSkull from './gold/decorations/skull.svg'

// Blue theme Halloween models
import blueChinaModel from './blue/models/china-model.png'
import blueEgyptModel from './blue/models/egypt-model.png'
import blueEnglandModel from './blue/models/england-model.png'
import blueGermanyModel from './blue/models/germany-model.png'
import blueGsbModel from './blue/models/gsb-model.png'
import blueHangsengModel from './blue/models/hangseng-model.png'
import blueIndiaModel from './blue/models/india-model.png'
import blueJapanModel from './blue/models/japan-model.png'
import blueKoreaModel from './blue/models/korea-model.png'
import blueLaosModel from './blue/models/laos-model.png'
import blueMalaysiaModel from './blue/models/malaysia-model.png'
import blueMaltaModel from './blue/models/malta-model.png'
import blueRussiaModel from './blue/models/russia-model.png'
import blueSingaporeModel from './blue/models/singapore-model.png'
import blueTaiwanModel from './blue/models/taiwan-model.png'
import blueThailandModel from './blue/models/thailand-model.png'
import blueUsaModel from './blue/models/usa-model.png'
import blueVietnamModel from './blue/models/vietnam-model.png'
import blueYeekeeModel from './blue/models/yeekee-model.png'

// Blue theme Sakura banner flags (EN)
import blueAomsinBannerFlag from './blue/background_flags/en/aomsin-banner-flag.png'
import blueChinaAfternoonStockBannerFlag from './blue/background_flags/en/china-afternoon-stock-banner-flag.png'
import blueChinaMorningStockBannerFlag from './blue/background_flags/en/china-morning-stock-banner-flag.png'
import blueDowjonesBannerFlag from './blue/background_flags/en/dowjones-banner-flag.png'
import blueEgyptBannerFlag from './blue/background_flags/en/egypt-banner-flag.png'
import blueEnglandBannerFlag from './blue/background_flags/en/england-banner-flag.png'
import blueGermanyBannerFlag from './blue/background_flags/en/germany-banner-flag.png'
import blueGovernmentSavingsBankBannerFlag from './blue/background_flags/en/government-savings-bank-banner-flag.png'
import blueGovernmentSetLotteryBannerFlag from './blue/background_flags/en/government-set-lottery-banner-flag.png'
import blueHangsengAfternoonStockBannerFlag from './blue/background_flags/en/hangseng-afternoon-stock-banner-flag.png'
import blueHangsengBannerFlag from './blue/background_flags/en/hangseng-banner-flag.png'
import blueHangsengMorningStockBannerFlag from './blue/background_flags/en/hangseng-morning-stock-banner-flag.png'
import blueHanoiBannerFlag from './blue/background_flags/en/hanoi-banner-flag.png'
import blueHanoiSpecialBannerFlag from './blue/background_flags/en/hanoi-special-banner-flag.png'
import blueHanoiVipBannerFlag from './blue/background_flags/en/hanoi-vip-banner-flag.png'
import blueIndiaBannerFlag from './blue/background_flags/en/india-banner-flag.png'
import blueJapanBannerFlag from './blue/background_flags/en/japan-banner-flag.png'
import blueKoreaBannerFlag from './blue/background_flags/en/korea-banner-flag.png'
import blueLaoStarStockBannerFlag from './blue/background_flags/en/lao-star-stock-banner-flag.png'
import blueLaosBannerFlag from './blue/background_flags/en/laos-banner-flag.png'
import blueLaosGroupSetBannerFlag from './blue/background_flags/en/laos-group-set-banner-flag.png'
import blueLaostarBannerFlag from './blue/background_flags/en/laostar-banner-flag.png'
import blueMalaysiaBannerFlag from './blue/background_flags/en/malaysia-banner-flag.png'
import blueMalaysiaStockBannerFlag from './blue/background_flags/en/malaysia-stock-banner-flag.png'
import blueNikkeiAfternoonStockBannerFlag from './blue/background_flags/en/nikkei-afternoon-stock-banner-flag.png'
import blueNikkeiMorningStockBannerFlag from './blue/background_flags/en/nikkei-morning-stock-banner-flag.png'
import blueRussiaBannerFlag from './blue/background_flags/en/russia-banner-flag.png'
import blueSingaporeBannerFlag from './blue/background_flags/en/singapore-banner-flag.png'
import blueTaiwanBannerFlag from './blue/background_flags/en/taiwan-banner-flag.png'
import blueThaiAfternoonStockBannerFlag from './blue/background_flags/en/thai-afternoon-stock-banner-flag.png'
import blueThaiGovernmentBankBannerFlag from './blue/background_flags/en/thai-government-bank-banner-flag.png'
import blueThaiGovernmentBankSetBannerFlag from './blue/background_flags/en/thai-government-bank-set-banner-flag.png'
import blueThaiGovernmentBannerFlag from './blue/background_flags/en/thai-government-banner-flag.png'
import blueThaiGovernmentSetBannerFlag from './blue/background_flags/en/thai-government-set-banner-flag.png'
import blueThaiMorningStockBannerFlag from './blue/background_flags/en/thai-morning-stock-banner-flag.png'
import blueThaiStockEveningBannerFlag from './blue/background_flags/en/thai-stock-evening-banner-flag.png'
import blueThaiStockPmBannerFlag from './blue/background_flags/en/thai-stock-pm-banner-flag.png'
import blueUsaBannerFlag from './blue/background_flags/en/usa-banner-flag.png'
import blueVietnamBannerFlag from './blue/background_flags/en/vietnam-banner-flag.png'
import blueYeekeeBannerFlag from './blue/background_flags/en/yeekee-banner-flag.png'
import blueYeekeeMaltaBannerFlag from './blue/background_flags/en/yeekee-malta-banner-flag.png'
import blueYeekeeVipBannerFlag from './blue/background_flags/en/yeekee-vip-banner-flag.png'

// Blue theme Halloween banner flags (Thai)
import blueAomsinBannerFlagTh from './blue/background_flags/thai/aomsin-banner-flag.png'
import blueChinaAfternoonStockBannerFlagTh from './blue/background_flags/thai/china-afternoon-stock-banner-flag.png'
import blueChinaMorningStockBannerFlagTh from './blue/background_flags/thai/china-morning-stock-banner-flag.png'
import blueDowjonesBannerFlagTh from './blue/background_flags/thai/dowjones-banner-flag.png'
import blueEgyptBannerFlagTh from './blue/background_flags/thai/egypt-banner-flag.png'
import blueEnglandBannerFlagTh from './blue/background_flags/thai/england-banner-flag.png'
import blueGermanyBannerFlagTh from './blue/background_flags/thai/germany-banner-flag.png'
import blueGovernmentSavingsBankBannerFlagTh from './blue/background_flags/thai/government-savings-bank-banner-flag.png'
import blueGovernmentSetLotteryBannerFlagTh from './blue/background_flags/thai/government-set-lottery-banner-flag.png'
import blueHangsengAfternoonStockBannerFlagTh from './blue/background_flags/thai/hangseng-afternoon-stock-banner-flag.png'
import blueHangsengBannerFlagTh from './blue/background_flags/thai/hangseng-banner-flag.png'
import blueHangsengMorningStockBannerFlagTh from './blue/background_flags/thai/hangseng-morning-stock-banner-flag.png'
import blueHanoiBannerFlagTh from './blue/background_flags/thai/hanoi-banner-flag.png'
import blueHanoiSpecialBannerFlagTh from './blue/background_flags/thai/hanoi-special-banner-flag.png'
import blueHanoiVipBannerFlagTh from './blue/background_flags/thai/hanoi-vip-banner-flag.png'
import blueIndiaBannerFlagTh from './blue/background_flags/thai/india-banner-flag.png'
import blueJapanBannerFlagTh from './blue/background_flags/thai/japan-banner-flag.png'
import blueKoreaBannerFlagTh from './blue/background_flags/thai/korea-banner-flag.png'
import blueLaoStarStockBannerFlagTh from './blue/background_flags/thai/lao-star-stock-banner-flag.png'
import blueLaosBannerFlagTh from './blue/background_flags/thai/laos-banner-flag.png'
import blueLaosGroupSetBannerFlagTh from './blue/background_flags/thai/laos-group-set-banner-flag.png'
import blueLaostarBannerFlagTh from './blue/background_flags/thai/laostar-banner-flag.png'
import blueMalaysiaBannerFlagTh from './blue/background_flags/thai/malaysia-banner-flag.png'
import blueMalaysiaStockBannerFlagTh from './blue/background_flags/thai/malaysia-stock-banner-flag.png'
import blueNikkeiAfternoonStockBannerFlagTh from './blue/background_flags/thai/nikkei-afternoon-stock-banner-flag.png'
import blueNikkeiMorningStockBannerFlagTh from './blue/background_flags/thai/nikkei-morning-stock-banner-flag.png'
import blueRussiaBannerFlagTh from './blue/background_flags/thai/russia-banner-flag.png'
import blueSingaporeBannerFlagTh from './blue/background_flags/thai/singapore-banner-flag.png'
import blueTaiwanBannerFlagTh from './blue/background_flags/thai/taiwan-banner-flag.png'
import blueThaiAfternoonStockBannerFlagTh from './blue/background_flags/thai/thai-afternoon-stock-banner-flag.png'
import blueThaiGovernmentBankBannerFlagTh from './blue/background_flags/thai/thai-government-bank-banner-flag.png'
import blueThaiGovernmentBankSetBannerFlagTh from './blue/background_flags/thai/thai-government-bank-set-banner-flag.png'
import blueThaiGovernmentBannerFlagTh from './blue/background_flags/thai/thai-government-banner-flag.png'
import blueThaiGovernmentSetBannerFlagTh from './blue/background_flags/thai/thai-government-set-banner-flag.png'
import blueThaiMorningStockBannerFlagTh from './blue/background_flags/thai/thai-morning-stock-banner-flag.png'
import blueThaiStockEveningBannerFlagTh from './blue/background_flags/thai/thai-stock-evening-banner-flag.png'
import blueThaiStockPmBannerFlagTh from './blue/background_flags/thai/thai-stock-pm-banner-flag.png'
import blueUsaBannerFlagTh from './blue/background_flags/thai/usa-banner-flag.png'
import blueVietnamBannerFlagTh from './blue/background_flags/thai/vietnam-banner-flag.png'
import blueYeekeeBannerFlagTh from './blue/background_flags/thai/yeekee-banner-flag.png'
import blueYeekeeMaltaBannerFlagTh from './blue/background_flags/thai/yeekee-malta-banner-flag.png'
import blueYeekeeVipBannerFlagTh from './blue/background_flags/thai/yeekee-vip-banner-flag.png'

export const HALLOWEEN_ASSETS = {
  gold: {
    logo: {
      light: goldLogoLight,
      dark: goldLogoDark,
    },
    loadingAssets: {
      backgrounds: {
        bg1: goldLoadingBg1,
      },
    },
    decorations: {
      abstractBorder: goldSkull,
      webLeft: goldWebLeft,
      webRight: goldWebRight,
    },
    models: {
      china: goldChinaModel,
      egypt: goldEgyptModel,
      england: goldEnglandModel,
      germany: goldGermanyModel,
      hangseng: goldHangsengModel,
      india: goldIndiaModel,
      japan: goldJapanModel,
      korea: goldKoreaModel,
      laos: goldLaosModel,
      malaysia: goldMalaysiaModel,
      malta: goldMaltaModel,
      russia: goldRussiaModel,
      singapore: goldSingaporeModel,
      taiwan: goldTaiwanModel,
      thailand: goldThailandModel,
      usa: goldUsaModel,
      vietnam: goldVietnamModel,
    } as Record<string, string>,
  },
  blue: {
    logo: {
      light: blueLogoLight,
      dark: blueLogoDark,
    },
    loadingAssets: {
      backgrounds: {
        bg1: blueLoadingBg1,
      },
    },
    decorations: {
      abstractBorder: blueSkull,
      cardLantern: blueSkull,
      webLeft: blueWebLeft,
      webRight: blueWebRight,
    },
    models: {
      china: blueChinaModel,
      egypt: blueEgyptModel,
      england: blueEnglandModel,
      germany: blueGermanyModel,
      gsb: blueGsbModel,
      hangseng: blueHangsengModel,
      india: blueIndiaModel,
      japan: blueJapanModel,
      korea: blueKoreaModel,
      laos: blueLaosModel,
      malaysia: blueMalaysiaModel,
      malta: blueMaltaModel,
      russia: blueRussiaModel,
      singapore: blueSingaporeModel,
      taiwan: blueTaiwanModel,
      thailand: blueThailandModel,
      usa: blueUsaModel,
      vietnam: blueVietnamModel,
      yeekee: blueYeekeeModel,
    } as Record<string, string>,
    // Banner flags for EN language only
    bannerFlagsEn: {
      'aomsin-lotto': blueAomsinBannerFlag,
      'china-afternoon-stock': blueChinaAfternoonStockBannerFlag,
      'china-morning-stock': blueChinaMorningStockBannerFlag,
      'dowjones-stock': blueDowjonesBannerFlag,
      'egypt-stock': blueEgyptBannerFlag,
      'england-stock': blueEnglandBannerFlag,
      'german-stock': blueGermanyBannerFlag,
      'government-savings-bank': blueGovernmentSavingsBankBannerFlag,
      'government-set-lottery': blueGovernmentSetLotteryBannerFlag,
      'hangseng-afternoon-stock': blueHangsengAfternoonStockBannerFlag,
      hangseng: blueHangsengBannerFlag,
      'hangseng-morning-stock': blueHangsengMorningStockBannerFlag,
      hanoi: blueHanoiBannerFlag,
      'hanoi-special': blueHanoiSpecialBannerFlag,
      'hanoi-vip': blueHanoiVipBannerFlag,
      'india-lotto': blueIndiaBannerFlag,
      'japan-lotto': blueJapanBannerFlag,
      'korea-stock': blueKoreaBannerFlag,
      'lao-star-stock': blueLaoStarStockBannerFlag,
      'laos-lotto': blueLaosBannerFlag,
      'laos-group-set': blueLaosGroupSetBannerFlag,
      laostar: blueLaostarBannerFlag,
      'malaysia-lotto': blueMalaysiaBannerFlag,
      'malaysia-stock': blueMalaysiaStockBannerFlag,
      'nikkei-afternoon-stock': blueNikkeiAfternoonStockBannerFlag,
      'nikkei-morning-stock': blueNikkeiMorningStockBannerFlag,
      'russia-stock': blueRussiaBannerFlag,
      'singapore-stock': blueSingaporeBannerFlag,
      'taiwan-stock': blueTaiwanBannerFlag,
      'thai-afternoon-stock': blueThaiAfternoonStockBannerFlag,
      'thai-government-bank': blueThaiGovernmentBankBannerFlag,
      'thai-government-bank-set': blueThaiGovernmentBankSetBannerFlag,
      'thai-government': blueThaiGovernmentBannerFlag,
      'thai-government-set': blueThaiGovernmentSetBannerFlag,
      'thai-government-bank-lotto': blueThaiGovernmentBankBannerFlag,
      'thai-government-bank-banner-flag': blueThaiGovernmentBankBannerFlag,
      'thai-government-bank-lotto-set': blueThaiGovernmentBankSetBannerFlag,
      'thai-government-lotto': blueThaiGovernmentBannerFlag,
      'thai-government-lotto-set': blueThaiGovernmentSetBannerFlag,
      'laos-group-set-banner-flag': blueLaosGroupSetBannerFlag,
      'thai-morning-stock': blueThaiMorningStockBannerFlag,
      'thai-stock-evening': blueThaiStockEveningBannerFlag,
      'thai-stock-pm': blueThaiStockPmBannerFlag,
      'usa-stock': blueUsaBannerFlag,
      'vietnam-lotto': blueVietnamBannerFlag,
      yeekee: blueYeekeeBannerFlag,
      'yeekee-malta': blueYeekeeMaltaBannerFlag,
      'yeekee-vip': blueYeekeeVipBannerFlag,
      'baac-lotto': blueThaiGovernmentBankBannerFlag, // Fallback
      stock: blueThaiGovernmentBankBannerFlag, // Fallback
      crypto: blueThaiGovernmentBankBannerFlag, // Fallback
    } as Record<string, string>,
    // Banner flags for Thai language
    bannerFlagsTh: {
      'aomsin-lotto': blueAomsinBannerFlagTh,
      'china-afternoon-stock': blueChinaAfternoonStockBannerFlagTh,
      'china-morning-stock': blueChinaMorningStockBannerFlagTh,
      'dowjones-stock': blueDowjonesBannerFlagTh,
      'egypt-stock': blueEgyptBannerFlagTh,
      'england-stock': blueEnglandBannerFlagTh,
      'german-stock': blueGermanyBannerFlagTh,
      'government-savings-bank': blueGovernmentSavingsBankBannerFlagTh,
      'government-set-lottery': blueGovernmentSetLotteryBannerFlagTh,
      'hangseng-afternoon-stock': blueHangsengAfternoonStockBannerFlagTh,
      hangseng: blueHangsengBannerFlagTh,
      'hangseng-morning-stock': blueHangsengMorningStockBannerFlagTh,
      hanoi: blueHanoiBannerFlagTh,
      'hanoi-special': blueHanoiSpecialBannerFlagTh,
      'hanoi-vip': blueHanoiVipBannerFlagTh,
      'india-lotto': blueIndiaBannerFlagTh,
      'japan-lotto': blueJapanBannerFlagTh,
      'korea-stock': blueKoreaBannerFlagTh,
      'lao-star-stock': blueLaoStarStockBannerFlagTh,
      'laos-lotto': blueLaosBannerFlagTh,
      'laos-group-set': blueLaosGroupSetBannerFlagTh,
      laostar: blueLaostarBannerFlagTh,
      'malaysia-lotto': blueMalaysiaBannerFlagTh,
      'malaysia-stock': blueMalaysiaStockBannerFlagTh,
      'nikkei-afternoon-stock': blueNikkeiAfternoonStockBannerFlagTh,
      'nikkei-morning-stock': blueNikkeiMorningStockBannerFlagTh,
      'russia-stock': blueRussiaBannerFlagTh,
      'singapore-stock': blueSingaporeBannerFlagTh,
      'taiwan-stock': blueTaiwanBannerFlagTh,
      'thai-afternoon-stock': blueThaiAfternoonStockBannerFlagTh,
      'thai-government-bank': blueThaiGovernmentBankBannerFlagTh,
      'thai-government-bank-set': blueThaiGovernmentBankSetBannerFlagTh,
      'thai-government': blueThaiGovernmentBannerFlagTh,
      'thai-government-set': blueThaiGovernmentSetBannerFlagTh,
      'thai-government-bank-lotto': blueThaiGovernmentBankBannerFlagTh,
      'thai-government-bank-banner-flag': blueThaiGovernmentBankBannerFlagTh,
      'thai-government-bank-lotto-set': blueThaiGovernmentBankSetBannerFlagTh,
      'thai-government-lotto': blueThaiGovernmentBannerFlagTh,
      'thai-government-lotto-set': blueThaiGovernmentSetBannerFlagTh,
      'laos-group-set-banner-flag': blueLaosGroupSetBannerFlagTh,
      'thai-morning-stock': blueThaiMorningStockBannerFlagTh,
      'thai-stock-evening': blueThaiStockEveningBannerFlagTh,
      'thai-stock-pm': blueThaiStockPmBannerFlagTh,
      'usa-stock': blueUsaBannerFlagTh,
      'vietnam-lotto': blueVietnamBannerFlagTh,
      yeekee: blueYeekeeBannerFlagTh,
      'yeekee-malta': blueYeekeeMaltaBannerFlagTh,
      'yeekee-vip': blueYeekeeVipBannerFlagTh,
      'baac-lotto': blueThaiGovernmentBankBannerFlagTh, // Fallback
      stock: blueThaiGovernmentBankBannerFlagTh, // Fallback
      crypto: blueThaiGovernmentBankBannerFlagTh, // Fallback
    } as Record<string, string>,
  },
} as const
